import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Spin } from "antd";

import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import BranchForm from "./component/BranchForm";
import { apiConfig, labelConfig, staticConfig } from "../systemAdmin.config";

const CreateBranch = (props) => {
  const { userData } = props;
  const { session } = userData;

  const [isLoading, setIsLoading] = useState(true);
  const [parentBranch, setParentBranch] = useState([]);
  const [officeTypeOptions, setOfficeTypeOptions] = useState([]);
  const [nearestBranchOptions, setNearestBranchOptions] = useState([]);
  const [countryIdData, setCountryIdData] = useState([]);
  const [stateProvinceIdData, setStateProvinceIdData] = useState([]);
  const [addressTypeIdData, setAddressTypeIdData] = useState([]);
  const [addressList, setAddressList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    getTemplate();
    getAddressTemplate();
  }, []);

  function getTemplate() {
    setIsLoading(true);
    BOM.FetchReqAction(
      { session },
      `${apiConfig.Office}/template`,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err);
          setIsLoading(false);
        } else {
          console.log(res);
          setParentBranch(
            (res?.allowedParents || []).map((el) => ({
              value: el.id,
              label: el.name,
            })),
          );
          setOfficeTypeOptions(
            (res?.officeTypes || []).map((el) => ({
              value: el.id,
              label: el.name,
            })),
          );
          setNearestBranchOptions(
            (res?.allowedNearestBranches || []).map((el) => ({
              value: el.id,
              label: el.name,
            })),
          );
          setIsLoading(false);
        }
      },
    );
  }

  function getAddressTemplate() {
    BOM.FetchReqAction(
      { session },
      `${apiConfig.Client}/addresses/template`,
      (err, res) => {
        if (err) return;
        setCountryIdData(
          (res?.countryIdOptions || []).map((el) => ({
            value: el.id,
            label: el.name,
          })),
        );
        setStateProvinceIdData(
          (res?.stateProvinceIdOptions || []).map((el) => ({
            value: el.id,
            label: el.name,
          })),
        );
        setAddressTypeIdData(
          (res?.addressTypeIdOptions || []).map((el) => ({
            value: el.id,
            label: el.name,
          })),
        );
      },
    );
  }

  return (
    <MainLayout isEnableRightSidebar={false}>
      <TopContent
        pageTitle={labelConfig.createBranch}
        pageItems={staticConfig.newBranch}
      />
      <Spin spinning={isLoading} size="large">
        <BranchForm
          parentBranch={parentBranch}
          officeTypeOptions={officeTypeOptions}
          nearestBranchOptions={nearestBranchOptions}
          countryIdData={countryIdData}
          stateProvinceIdData={stateProvinceIdData}
          addressTypeIdData={addressTypeIdData}
          addressList={addressList}
          setAddressList={setAddressList}
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          session={session}
          BOM={BOM}
          apiConfig={apiConfig}
          cnt={cnt}
          setIsLoading={setIsLoading}
        />
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, null)(CreateBranch);
